import styles from './breakpoints.module.scss';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface BreakpointsProps {
  children?: any;
}

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400
    }
  }
})

export function BreakpointsProvider({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
}

export default BreakpointsProvider;